import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationsState } from './notifications.models';
import { NOTIFICATIONS_FEATURE_KEY } from './notifications.reducer';

export const selectFeature = createFeatureSelector<NotificationsState>(NOTIFICATIONS_FEATURE_KEY);

export const getNotifications = createSelector(selectFeature, (state: NotificationsState) => state?.listOfNotifications);

export const getScheduledNotifications = createSelector(selectFeature, (state: NotificationsState) => state?.scheduled);

export const getCounter = createSelector(selectFeature, (state: NotificationsState) => state?.count);

export const getCurrentAction = createSelector(selectFeature, (state: NotificationsState) => state?.actionOnNotification);
